var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscriptionsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5C20.5 6.65685 16.9183 8 12.5 8C8.08172 8 4.5 6.65685 4.5 5M20.5 5C20.5 3.34315 16.9183 2 12.5 2C8.08172 2 4.5 3.34315 4.5 5M20.5 5L20.5 19C20.5 20.6569 16.9183 22 12.5 22C8.08172 22 4.5 20.6569 4.5 19L4.5 5M20.5 9.6666C20.5 11.3235 16.9183 12.6666 12.5 12.6666C8.08172 12.6666 4.5 11.3235 4.5 9.6666M20.5 14.33C20.5 15.9869 16.9183 17.33 12.5 17.33C8.08172 17.33 4.5 15.9869 4.5 14.33",
    stroke: "#091523",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsBlack);
export default __webpack_public_path__ + "static/media/subscriptionsBlack.064c1d7c77cf036e53dd38f628e83c30.svg";
export { ForwardRef as ReactComponent };